import moengage from "@moengage/web-sdk";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

export const isStageLogin = (uuid, mobNum, source) => {
  moengage.add_unique_user_id(uuid);

  function generateTimestamp() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
    const day = String(now.getDate()).padStart(2, "0"); // Add leading zero for single-digit days

    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const second = String(now.getSeconds()).padStart(2, "0");

    // Calculate timezone offset
    const timezoneOffset = now.getTimezoneOffset();
    const absOffset = Math.abs(timezoneOffset);
    const offsetHours = String(Math.floor(absOffset / 60)).padStart(2, "0");
    const offsetMinutes = String(absOffset % 60).padStart(2, "0");
    const offsetSign = timezoneOffset <= 0 ? "+" : "-"; // Negative offset means positive time zone and vice versa

    const timestamp = `${year}-${month}-${day}T${hour}:${minute}:${second}${offsetSign}${offsetHours}:${offsetMinutes}`;

    return timestamp;
  }

  const timestamp = generateTimestamp();

  // console.log("ENDPOINT:  ",sessionStorage.getItem("URLEndpoint"));

  if (sessionStorage.getItem("URLEndpoint") === "login") {
    sessionStorage.removeItem("URLEndpoint");
    setTimeout(() => {
      moengage.track_event("login", {
        mobileNum: mobNum,
        dsa_hash: sessionStorage.getItem("dsa_hash") ? sessionStorage.getItem("dsa_hash") : "null",
        utm_source: sessionStorage.getItem("utm_source") ? sessionStorage.getItem("utm_source") : "null",
        utm_medium: sessionStorage.getItem("utm_medium") ? sessionStorage.getItem("utm_medium") : "null",
        utm_campaign: sessionStorage.getItem("utm_campaign") ? sessionStorage.getItem("utm_campaign") : "null",
        utm_term: sessionStorage.getItem("utm_term") ? sessionStorage.getItem("utm_term") : "null",
        utm_content: sessionStorage.getItem("utm_content") ? sessionStorage.getItem("utm_content") : "null",
        application_form_number: sessionStorage.getItem("application_form_no"),
        "journey name": source,
        timestamp: timestamp,
      });
      sessionStorage.removeItem("utm_source");
      sessionStorage.removeItem("utm_medium");
      sessionStorage.removeItem("utm_campaign");
      sessionStorage.removeItem("utm_term");
      sessionStorage.removeItem("utm_content");
    }, 1000);
    return;
  }
  else {
    return;
  }
};
